export function hideBootsplash() {
  // no-op
}
